/*
  <capra-slides>: the detail photos under a product (snippets/product-details.liquid),
  one at a time on every screen (owner, 2026-10-16). Without this script they are a
  sideways strip that snaps photo by photo (swipe, trackpad, keyboard scroll). With it:
  arrows on wide screens and arrow keys step one photo, in a loop: after the last
  comes the first, and back; and every photo loads as the slideshow nears the screen,
  so the next one is always there.
*/
class CapraSlides extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track || this.track.children.length < 2) return;
    for (const [selector, direction] of [['[data-prev]', -1], ['[data-next]', 1]]) {
      const arrow = this.querySelector(selector);
      if (!arrow) continue;
      arrow.hidden = false;
      arrow.addEventListener('click', () => this.step(direction));
    }
    const warm = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      for (const img of this.track.querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
      warm.disconnect();
    }, { rootMargin: '100% 0px' });
    warm.observe(this);
    this.track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
    });
  }

  // Photos sit a small gap apart: measure where each starts rather than multiplying widths
  step(direction) {
    const items = [...this.track.children];
    const start = (item) => item.offsetLeft - items[0].offsetLeft;
    const left = this.track.scrollLeft;
    const here = items.reduce((best, item, i) => Math.abs(start(item) - left) < Math.abs(start(items[best]) - left) ? i : best, 0);
    this.track.scrollTo({ left: start(items[(here + direction + items.length) % items.length]) });
  }
}

if (!customElements.get('capra-slides')) customElements.define('capra-slides', CapraSlides);
